import React from 'react';
import { Link } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import StarIcon from '@material-ui/icons/Star';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import CloseIcon from '@material-ui/icons/Close';

import Map from "../../containers/EmployeeWeb/utils/MapaDetalheEvento";
import IconButton from '@material-ui/core/IconButton';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

const styles = (theme) => ({
    paperWidth: {
        width: '400px',
        height: '525px',
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const TaskScheduleDialog = ({
    classes, open, onClose, schedule, scheduleActions, isPremium,
}) => {

    const allCoords = [{ lat: schedule.rulerdetailsjson.timeclockLocation.lat, lng: schedule.rulerdetailsjson.timeclockLocation.long, type: schedule.timeclock.type, schedule: schedule }]
    const center = Object.assign({}, allCoords[0]) //copia o primeiro item de allCoords
    for (let loc of schedule.rulerdetailsjson.allowedLocations) {
        loc.type = 'LocalPermitido'
        loc.lng = loc.long //gambiarra para que o mapa busque a prop lng
        center.lat = (+center.lat + +loc.lat) / 2
        center.lng = (+center.lng + +loc.long) / 2
        allCoords.push(loc)
    }

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            PaperProps={{ classes: { root: classes.paperWidth } }}
        >

            <DialogTitle>Localização do Ponto</DialogTitle>
            <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                <CloseIcon />
            </IconButton>

            <Map
                locations={allCoords}
                center={allCoords[0]}
            />
            {isPremium == true ?
                (
                    <DialogActions>
                        <DialogContentText style={{ fontSize: '14px', color: '#2880ca', marginRight: '300px', flex: 'none' }}>
                            *Clique nas marcações para ver detalhes.
                        </DialogContentText>
                        <Button style={{ backgroundColor: 'rgb(247, 99, 99)' }} onClick={item => scheduleActions('REJEITADO', schedule.id)} variant="contained" color="primary" autoFocus>
                            Rejeitar
                        </Button>
                        <Button style={{ backgroundColor: 'rgb(70 160 69)' }} onClick={item => scheduleActions('APROVADO', schedule.id)} variant="contained" color="primary" autoFocus>
                            Aprovar
                        </Button>
                    </DialogActions>
                ) :
                <DialogActions>
                    <DialogContentText style={{ fontSize: '14px', color: '#2880ca', marginBottom: '3px' }}>
                        *Assine o Plano Premium e Aprove ou Rejeite o ponto por aqui.
                    </DialogContentText>
                    <Button variant="contained" color="primary" component={Link} to='/assinatura'>
                        <StarIcon /> FACILITE! SEJA PREMIUM <StarIcon />
                    </Button>
                </DialogActions>
            }
        </Dialog >
    );
};

export default withStyles(styles)(TaskScheduleDialog);
